module.exports = __webpack_public_path__ + "img/icon-add-inverted.60d0cd07.svg";